/**
 * Routes whose HTTP errors should NOT trigger a global snackbar notification.
 * Add entries here for background polls, optional fetches, or silent retries.
 *
 * Example:
 *   { status: 404, method: 'GET', urlPattern: /\/notifications\/poll/ }
 */
export interface INonInterceptedRoute {
  status: number;
  method: string;
  urlPattern: RegExp;
}

export const NON_INTERCEPTED_ROUTES: INonInterceptedRoute[] = [
  // Silence 401 on token refresh — auth guard handles the redirect
  { status: 401, method: 'POST', urlPattern: /\/auth\/refresh_token/ },
];
